export default function (initialDataInteractor, questionnaireId, questionData) {
  initialDataInteractor.data.questionnaires
    .find(q => q.id == questionnaireId)
    .questions
    .push(questionData);
}